import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import {
    PrimaryButton,
    SecondaryButton,
} from '@acko-tech/building-blocks.ui.button';
import * as Styles from './styles';

interface IProps {
    image: string;
    text: string;
    subText?: string;
    onClick: any;
}

function Confirmation({ image, text, subText, onClick }: IProps) {
    return (
        <Styles.Wrapper>
            <Styles.ImageFlex>
                <Image
                    width={'80px'}
                    height={'80px'}
                    alt={''}
                    src={getImageBasePath(image)}
                />
            </Styles.ImageFlex>
            <Styles.Text>{text}</Styles.Text>
            {subText && <Styles.SubText>{subText}</Styles.SubText>}
            <Styles.ButtonsRow>
                <Styles.ButtonWrapper>
                    <SecondaryButton onClick={(e) => onClick(e, 'no')}>
                        No
                    </SecondaryButton>
                </Styles.ButtonWrapper>
                <Styles.ButtonWrapper>
                    <PrimaryButton onClick={(e) => onClick(e, 'yes')}>
                        Yes
                    </PrimaryButton>
                </Styles.ButtonWrapper>
            </Styles.ButtonsRow>
        </Styles.Wrapper>
    );
}

export default Confirmation;
